import React, { useState, useEffect, useMemo, useCallback } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// Data for academic staff
const academicStaff = [
    { id: 1, name: "डॉ. जगत नारायण", designation: "सह-आचार्य", faculty: "साहित्य", email: "jagatkuk@gmail.com", mobile: "9996041064", photo: "डॉ. जगत नारायण.JPG" },
    { id: 2, name: "डॉ. सुरेन्द्र पाल", designation: "सह-आचार्य", faculty: "व्याकरण", email: "surendervats1974@gmail.com", mobile: "9896335373", photo: "डॉ. सुरेन्द्र पाल वत्स (विभागाध्यक्ष, व्याकरण).jpg" },
    { id: 3, name: "डॉ. रामानन्द मिश्र", designation: "सहायक आचार्य", faculty: "साहित्य", email: "ramachd91@gmail.com", mobile: "7355115414", photo: "डॉ. रामानन्द मिश्र (साहित्य विभाग).jpg" },
    { id: 4, name: "डॉ. नरेश शर्मा", designation: "सहायक आचार्य", faculty: "ज्योतिष", email: "nareshdutt82@gmail.com", mobile: "7082811234", photo: "डॉ. नरेश शर्मा (विभागाध्यक्ष, ज्योतिष विभाग).jpg" },
    { id: 5, name: "डॉ. अखिलेश कुमार मिश्र", designation: "सहायक आचार्य", faculty: "वेद", email: "akhimishra111@gmail.com", mobile: "7631274367", photo: "डॉ. अखिलेश कुमार मिश्र, विभागाध्यक्ष (वेद).jpg" },
    { id: 6, name: "डॉ. कृष्ण चन्द्र पाण्डेय", designation: "सहायक आचार्य", faculty: "साहित्य", email: "krishnapandey1967@gmail.com", mobile: "9810373278", photo: "डॉ. कृष्ण चन्द्र पाण्डे (विभागाध्यक्ष, हिन्दू अध्ययन).JPG" },
    { id: 7, name: "डॉ. शर्मिला", designation: "सहायक आचार्य", faculty: "व्याकरण", email: "omsharmila88@gmail.com", mobile: "9254640788", photo: "डॉ. शर्मिला (व्याकरण विभाग).jpg" },
    { id: 8, name: "डॉ. नवीन शर्मा", designation: "सहायक आचार्य (अनुबन्ध)", faculty: "ज्योतिष", email: "astronaveen1983@gmail.com", mobile: "9650834736", photo: "डॉ. नवीन शर्मा (ज्योतिष विभाग).jpg" },
    { id: 9, name: "डॉ. विनय गोपाल त्रिपाठी", designation: "सहायक आचार्य (अनुबन्ध)", faculty: "दर्शन", email: "hncgoa89@gmail.com", mobile: "8076723202", photo: "डॉ. विनय गोपाल त्रिपाठी (दर्शन विभाग).JPG" },
    { id: 10, name: "डॉ. चन्द्र कान्त", designation: "सहायक आचार्य (अनुबन्ध)", faculty: "ज्योतिष", email: "mr.cksharma@gmail.com", mobile: "7018781438", photo: "डॉ चन्द्रकान्त (ज्योतिष विभाग).jpg" },
    { id: 11, name: "डॉ. हरीश कुमार", designation: "सहायक आचार्य (अनुबन्ध)", faculty: "हिन्दू अध्ययन", email: "rishibhawan@gmail.com", mobile: "7988376657", photo: "डॉ. हरीश कुमार (हिन्दु अध्ययन).jpg" },
    { id: 12, name: "डॉ. देवेन्द्र सिंह", designation: "सहायक आचार्य (अनुबन्ध)", faculty: "योग", email: "devender.banger85@gmail.com", mobile: "9911872115", photo: "डॉ. देवेन्द्र सिंह (योग विभाग).jpg" },
    { id: 13, name: "डॉ. कुलदीप सिंह", designation: "सहायक आचार्य (अनुबन्ध)", faculty: "धर्मशास्त्र", email: "drkuldeepsingh934@gmail.com", mobile: "9248300000", photo: "डॉ कुलदीप सिंह (धर्मशास्त्र विभाग).jpeg" },
    { id: 14, name: "डॉ. गोविन्द वल्लभ", designation: "सहायक आचार्य (अनुबन्ध)", faculty: "ज्योतिष", email: "gballabh92k@gmail.com", mobile: "7011504209", photo: "डॉ. गोविन्द बल्लभ (ज्योतिष विभाग).JPG" }
];

// Data for non-academic officers and members (no 'photo' property needed here)
const nonAcademicOfficersAndMembers = [
    { id: 1, name: "डॉ. जगत नारायण", designation: "उपकुलसचिव (अतिरिक्त कार्यभार)", branch: "उपकुलसचिव कार्यालय", email: "deputyregistrar@mvsu.ac.in" },
    { id: 2, name: "श्री सुभाष चन्द", designation: "अधीक्षक", branch: "अधीक्षक (प्रशासन शाखा, सम्पादा अधिकारी, जनरल & क्रय शाखा एवं अधीक्षक - Dean of College)", email: "subhashgillgju@gmail.com" },
    { id: 3, name: "श्री अंकुर गुप्ता", designation: "अधीक्षक (प्रतिनियुक्ति)", branch: "वित्त, शैक्षणिक, स्टोर एवं नॉडल अधिकारी HRMS, SPIO )", email: "ankurgupta2222@gmail.com" },
    { id: 4, name: "श्री संजीव कुमार", designation: "अधीक्षक (प्रतिनियुक्ति)", branch: "अधीक्षक (प्रतिनियुक्ति) अधीक्षक (परीक्षा शाखा, पंजीकरण शाखा एवं HRMS -Checker) ", email: "Sobindlish999@gmail.com" },
    { id: 5, name: "श्री विकास कटारिया", designation: "सहायक (प्रतिनियुक्ति)", branch: "कुलपति कार्यालय,, जनरल एवं क्रय शाखा", email: "katatiavikas784@gmail.com" },
    { id: 6, name: "श्री इन्द्रजीत", designation: "सहायक (प्रतिनियुक्ति)", branch: "प्रशासन शाखा, सहायक- Dean of College, HRMS Checker)", email: "inderjeetgju@gmail.com" },
    { id: 7, name: "श्री प्रवीन कुमार", designation: "सहायक (प्रतिनियुक्ति)", branch: "शैक्षणिक शाखा, पंजीकरण, छात्रवृत्ति एवं AISHE", email: "pkror89@gmail.com" },
    { id: 8, name: "श्रीमती संगीता", designation: "लिपिक (प्रतिनियुक्ति)", branch: "वित्त शाखा", email: "riya.gill90@gmail.com" },
    { id: 9, name: "श्री चिराग", designation: "स्टेनों (टाईपिस्ट)", branch: "कुलसचिव कार्यालय", email: "chiragsingla7575@gmail.com" },
    { id: 10, name: "श्री सुनील शर्मा", designation: "कनिष्ठ अभियन्ता", branch: "निर्माण शाखा", email: "sunilsharmajaswas@gmail.com" },
    { id: 11, name: "श्री देवव्रत", designation: "लिपिक (HKRN)", branch: "कुलपति कार्यालय", email: "dev24koshal@gmail.com" },
    { id: 12, name: "श्री अरूण दत्त", designation: "लिपिक (HKRN)", branch: "स्टोर एवं क्रय शाखा", email: "arundatt87@gmail.com" },
    { id: 13, name: "श्री विनय", designation: "लिपिक (HKRN)", branch: " वित्त शाखा", email: "vineyattry97@gmail.com" },
    { id: 14, name: "श्री रमेश चन्द्र", designation: "लिपिक (HKRN)", branch: "पुस्तकालय, छात्र कल्याण अधिष्ठाता, पुरुष एवं महिला छात्रावास", email: "parasharramesh095@gmail.com" },
    { id: 15, name: "श्री सीता राम", designation: "लिपिक (HKRN)", branch: "वेद, व्याकरण, ज्योतिष, साहित्य, दर्शन, योग एवं डिप्लोमा पाठ्यक्रम के लिपिकीय कार्य", email: "sitaramsharma385@gmail.com" },
    { id: 16, name: "श्रीमती स्वीटी", designation: "लिपिक (HKRN)", branch: "प्रशासन शाखा", email: "sweetysardana1981@gmail.com" },
    { id: 17, name: "श्री मुकेश कुमार", designation: "लिपिक (HKRN)", branch: "शोध एवं प्रकाशन विभाग, महर्षि वाल्मीकि शोध पीठ, भारतीय ज्ञान-परम्परा शोध एवं प्रशिक्षण केन्द्र, जनसम्पर्क अधिकारी (PRO), कम्प्यूटर लैब इन्चार्ज एवं विश्वविद्यालय के डिजाईनिंग सम्बन्धित कार्य (उक्त विभागों/पीठों के लिपिकीय कार्य)", email: "mukeshkaushik680@gmail.com" },
    { id: 18, name: "श्री अजय कुमार", designation: "लिपिक (HKRN)", branch: "प्रशासन", email: "ajay.keorak143@gmail.com" },
    { id: 19, name: "श्रीमती स्वीटी", designation: "लिपिक (HKRN)", branch: "वित्त शाखा", email: "sweetykaushik274@gmail.com" },
    { id: 20, name: "श्री कुलवन्त सिंह", designation: "लिपिक (HKRN)", branch: "पुस्तकालय, सरस्वती वैदिक सभ्यता शोध केन्द्र, कपिष्ठल कठ संहिता", email: "ks6979333@gmail.com" },
    { id: 21, name: "श्री दीपक शर्मा", designation: "लिपिक (HKRN)", branch: "ऑडिट शाखा", email: "aacharyadeep1990@gmail.com" },
    { id: 22, name: "श्री महावीर", designation: "लिपिक (HKRN)", branch: "शैक्षणिक शाखा", email: "dr.mahavir1981@gmail.com" },
    { id: 23, name: "श्री जयबीर सिंह", designation: "डी. ई. ओ. (HKRN)", branch: "उप-कुलसचिव कार्यालय", email: "javeerkumar16796@gmail.com" },
    { id: 24, name: "श्रीमती मीना रानी", designation: "डी. ई. ओ. (HKRN)", branch: "कुलसचिव कार्यालय", email: "meenaranikurar@gmail.com" },
    { id: 25, name: "श्रीमती अनिता", designation: "डी. ई. ओ. (HKRN)", branch: "अधिष्ठाता शैक्षणिक व धर्मशास्त्र विभाग", email: "wadhwaanitaa@gmail.com" },
    { id: 26, name: "श्रीमती आरती शर्मा", designation: "डी. ई. ओ. (HKRN)", branch: "परीक्षा शाखा", email: "artiyashu82@gmail.com" },
    { id: 27, name: "श्रीमती सविता रानी", designation: "डी. ई. ओ. (HKRN)", branch: "परीक्षा शाखा", email: "savita446@gmail.com" },
    { id: 28, name: "श्रीमती स्वाती सिंह", designation: "डी. ई. ओ. (HKRN)", branch: "परीक्षा शाखा", email: "swatisahrawat408@gmail.com" },
    { id: 29, name: "श्रीमती मंजू रानी", designation: "डी. ई. ओ. (HKRN)", branch: "परीक्षा शाखा", email: "manjuudhull@gmail.com" },
    { id: 30, name: "श्रीमती निर्मला देवी", designation: "डी. ई. ओ. (HKRN)", branch: "पंजीकरण शाखा", email: "mannumannu48264@gmail.com" },
    { id: 31, name: "श्री संजीव कुमार", designation: "डी. ई. ओ. (HKRN)", branch: "प्रशासन शाखा, अधिष्ठाता महाविद्यालय", email: "keoraksanju@gmail.com" },
    { id: 32, name: "श्री साहिल शर्मा", designation: "डी. ई. ओ. (HKRN)", branch: "वित्त शाखा एवं बस पास", email: "drsahilbhardwaj0@gmail.com" },
    { id: 33, name: "श्री सिकन्दर लाल", designation: "डी. ई. ओ. (HKRN)", branch: "छात्रवृत्ति शाखा एवं खेल विभाग", email: "lalsikander123@gmail.com" },
    { id: 34, name: "श्री दीपक", designation: "डी. ई. ओ. (HKRN)", branch: "परीक्षा शाखा", email: "deepakbhardwaj2455@gmail.com" },
    { id: 35, name: "श्री अंकुर", designation: "डी. ई. ओ. (HKRN)", branch: "बायोमैट्रिक मशीन, सी.एम. विन्डो, SPIO लिपिक, HRMS (Maker), ई-मेल कन्सौल एवं प्रशासन शाखा के डायरी, डिस्पैच एवं डाक टिकट ", email: "asbairagiofficial@gmail.com" },
    { id: 36, name: "श्री राकेश कुमार", designation: "डी. ई. ओ. (HKRN)", branch: "NAD/Digi-locker", email: "rakeshkeorak03@gmail.com" },
    { id: 37, name: "श्री तरसेम कुमार", designation: "डी. ई. ओ. (HKRN)", branch: "केयर टेकर (टीक परिसर), परिवहन विभाग", email: "tarsemdeora772@gmail.com" },
    { id: 38, name: "श्री अमरदीप शर्मा", designation: "डी. ई. ओ. (HKRN)", branch: "परीक्षा शाखा एवं IQAC", email: "amardeepsharma1008@gmail.com" },
    { id: 39, name: "श्रीमती मीनू शर्मा", designation: "डी. ई. ओ. (HKRN)", branch: "परीक्षा शाखा", email: "amardeep.bs4@gmail.com" },
    { id: 40, name: "श्री विकास", designation: "दफ्तरी (HKRN)", branch: "वित्त शाखा", email: "vkygurjar674@gmail.com" },
    { id: 41, name: "श्री विकास", designation: "दफ्तरी (HKRN)", branch: "निर्माण शाखा", email: "vikasatri70@gmail.com" }
];


const departments = [
    { name: "शैक्षणिक सदस्य", data: academicStaff },
    { name: "गैर–शैक्षणिक अधिकारी एवं सदस्य", data: nonAcademicOfficersAndMembers }
];

// Function to get staff photo path
const getStaffPhoto = (photoName) => {

    try {
        return require(`./../assets/Photos/${photoName}`);
    } catch (error) {
        return "https://via.placeholder.com/60";
    }
};

export default function UniversityStaff() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [selectedDeptIndex, setSelectedDeptIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth >= 768) setShowSidebar(true);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const selectedDepartment = useMemo(() => departments[selectedDeptIndex], [selectedDeptIndex]);
    const handleDepartmentClick = useCallback((index) => {
        setSelectedDeptIndex(index);
        if (isMobile) setShowSidebar(false);
    }, [isMobile]);

    const isNonAcademicStaff = selectedDepartment.name === "गैर–शैक्षणिक अधिकारी एवं सदस्य";

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light font-inter">
            <button
                className="btn text-white d-md-none m-2 fw-bold"
                style={{ backgroundColor: "#77236b" }}
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            <aside
                className={`text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3`}
            >
                <h5 className="text-center fw-bold mb-3">विश्वविद्यालय सदस्य</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            className={`mb-1 p-2 rounded shadow-sm small ${selectedDeptIndex === index
                                ? "text-white fw-bold border border-light"
                                : "bg-light text-dark"
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: selectedDeptIndex === index ? "#77236b" : undefined
                            }}
                            onClick={() => handleDepartmentClick(index)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto m-2">
                <h5 className="mb-3 text-center fw-bold">
                    {selectedDepartment.name}
                </h5>

                {isNonAcademicStaff ? (
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover table-striped small">
                            <thead className="table-dark text-center">
                                <tr>
                                    <th>क्रम</th>
                                    <th>नाम</th>
                                    <th>पद</th>
                                    <th>शाखा</th>
                                    <th>ईमेल</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedDepartment.data.map((staff, index) => (
                                    <tr key={staff.id}>
                                        <td className="text-center">{index + 1}</td>
                                        <td>{staff.name}</td>
                                        <td>{staff.designation}</td>
                                        <td>{staff.branch}</td>
                                        <td>
                                            <a href={`mailto:${staff.email}`}>{staff.email}</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="row">
                        {selectedDepartment.data.map((staff) => (
                            <div className="col-12 col-sm-6 mb-4" key={staff.id}>
                                <div
                                    className="border p-3 h-100 d-flex shadow"
                                    style={{
                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // custom box shadow
                                        borderRadius: "8px", // थोड़ा गोल लुक के लिए
                                        backgroundColor: "#fff" // बैकग्राउंड सफेद रखें
                                    }}
                                >
                                    {/* Photo */}
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            border: "2px solid #77236b",
                                            fontWeight: "bold",
                                            fontSize: "20px",
                                            flexShrink: 0
                                        }}
                                    >
                                        <img
                                            src={getStaffPhoto(staff.photo)}
                                            alt={staff.name}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain"
                                            }}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "https://via.placeholder.com/120?text=चित्र";
                                            }}
                                        />
                                    </div>

                                    {/* Text Info */}
                                    <div className="ms-3">
                                        <p className="mb-1 fw-bold">नाम: {staff.name}</p>
                                        <p className="mb-1 fw-bold">पद: {staff.designation}</p>
                                        <p className="mb-1 fw-bold">विभाग: {staff.faculty}</p>
                                        <p className="mb-1 fw-bold">
                                            आधिकारिक ई-मेल: <a href={`mailto:${staff.email}`}>{staff.email}</a>
                                        </p>
                                        <p className="mb-1 fw-bold">मोबाइल: {staff.mobile}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                )}
            </main>
        </div>
    );
}